import {
  BillableElement,
  PartPlacementCheckState,
} from "../reducers/uploadedBoard";

export function elementShouldCheckPlacement(element: BillableElement): boolean {
  return (
    element.part_placement_check.state == PartPlacementCheckState.SHOULD_CHECK
  );
}

export function elementHasPlacementError(element: BillableElement): boolean {
  return element.part_placement_check.state == PartPlacementCheckState.FAILED;
}

export function elementHasPlacementWarning(
  userIsAdminOrEngineer: boolean,
  element: BillableElement,
): boolean {
  if (!userIsAdminOrEngineer) {
    return elementHasMissingPlacementInfo(element);
  }
  return (
    elementHasMissingPlacementInfo(element) ||
    elementHasMissingFootprintInfo(element) ||
    elementCannotCheckPlacement(element) ||
    elementShouldCheckPlacement(element)
  );
}

export function elementHasMissingPlacementInfo(
  element: BillableElement,
): boolean {
  return element.placement === null;
}

export function elementHasMissingFootprintInfo(
  element: BillableElement,
): boolean {
  return (
    element.part_placement_check.state ==
    PartPlacementCheckState.MISSING_FOOTPRINT_INFO
  );
}

export function elementCannotCheckPlacement(element: BillableElement): boolean {
  return (
    element.part_placement_check.state == PartPlacementCheckState.CANNOT_CHECK
  );
}

export function elementHasGoodPlacement(element: BillableElement): boolean {
  return element.part_placement_check.state == PartPlacementCheckState.PASSED;
}
